// Meta Pixel helpers. Privacy: never pass PII or sensitive data (names, ages,
// locations, audio/video, health) to Meta. The reservation number is NEVER
// transmitted to Meta — not as a custom parameter and not as eventID. It is
// used only as a local, in-memory key to prevent duplicate Lead events.

const firedLeads = new Set();

const randomEventId = () =>
  typeof window !== "undefined" && window.crypto && window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : `evt_${Date.now()}_${Math.random().toString(36).slice(2)}`;

export const trackPageView = () => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView");
  }
};

// Fire a standard Lead once per successful reservation.
// `dedupKey` (e.g. the reservation number) is used ONLY locally to prevent
// duplicate fires — it is never sent to Meta. A random, non-PII eventID is
// generated for Pixel/CAPI deduplication.
export const trackLead = (dedupKey) => {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  if (dedupKey) {
    if (firedLeads.has(dedupKey)) return;
    firedLeads.add(dedupKey);
  }
  window.fbq(
    "track",
    "Lead",
    { content_category: "reservation", content_name: "Vsense Reservation" },
    { eventID: randomEventId() }
  );
};
